(function () {
    "use strict";
    angular
        .module("common.services")
        .factory("accountsResource", ["$resource", accountsResource]);
    function accountsResource($resource) {
        return $resource("/api/accounts/:personSeq/:action/:actionValue/:extraAction", { personSeq: "@personSeq", action: "@action", actionValue: "@actionValue", extraAction: "@extraAction" }, {
            deleteUser: {
                method: "POST",
                params: { action: "deleteUser" }
            },
            getModificationNotes: {
                method: "GET",
                params: { action: "modificationNotes" },
                isArray: true
            },
            isUsernameAvailable: {
                method: "GET",
                params: { action: "isUsernameAvailable" }
            },
            addToGroup: {
                method: "POST",
                params: { action: "groups" }
            },
            removeFromGroup: {
                method: "POST",
                params: { action: "groups", extraAction: "remove" },
                hasBody: true
            },
            updateAccountSettings: {
                method: "POST",
                params: { action: "accountSettings" }
            },
            resetAccountPassword: {
                method: "POST",
                params: { action: "resetPassword" }
            },
            bulkAdd: {
                method: "POST",
                params: { action: "bulkAdd" }
            },
            getAssignPathToLearnerLearnersListViewModel: {
                method: "GET",
                params: { action: "assignPathToLearnerLearnersListViewModel" }
            },
            getExternalLogins: {
                method: "GET",
                params: { action: "externalLogins" },
                isArray: true
            },
            getName: {
                method: "GET",
                cache: true,
                params: { action: "name" }
            },
            getOrders: {
                method: "GET",
                params: { action: "orders" },
                isArray: true
            },
            getInventorySummaryListViewModel: {
                method: "GET",
                params: { action: "inventorySummaryListViewModel" }
            },
            updatePersonalInformation: {
                method: "POST",
                params: { action: "updatePersonalInformation" }
            },
            updateAccountInformation: {
                method: "POST",
                params: { action: "updateAccountInformation" }
            },
            updateBillingInformation: {
                method: "POST",
                params: { action: "updateBillingInformation" }
            },
            addExternalLogin: {
                method: "POST",
                params: { action: "addExternalLogin" }
            },
            removeExternalLogin: {
                method: "POST",
                params: { action: "removeLogin" }
            },
            merge: {
                method: "POST",
                params: { action: "merge" }
            },
            getMergeAccountLogs: {
                method: "GET",
                params: { action: "mergeAccountLogs" }
            },
        });
    }
}());
